import type { QueueOrder } from '@/lib/schemas/queue'

export type QueueFilter = 'all' | 'eligible' | 'vip'

/** All / Has Eligible Items (eligible_count > 0) / VIP Only. */
export function filterByCategory(orders: QueueOrder[], filter: QueueFilter): QueueOrder[] {
  switch (filter) {
    case 'eligible':
      return orders.filter((o) => o.eligible_count > 0)
    case 'vip':
      return orders.filter((o) => o.is_vip)
    default:
      return orders
  }
}

/** Case-insensitive substring match on order number, customer name, or any KH SKU. */
export function searchOrders(orders: QueueOrder[], query: string): QueueOrder[] {
  const q = query.trim().toLowerCase()
  if (!q) return orders
  return orders.filter(
    (o) =>
      o.order_number.toLowerCase().includes(q) ||
      o.customer_name.toLowerCase().includes(q) ||
      o.kh_skus.some((sku) => sku.toLowerCase().includes(q)),
  )
}
